import { Injectable } from '@angular/core';
import { NameValuePair } from 'src/app/models/NameValuePair';
import { MasterDataTypes } from 'src/app/models/SystemEnums';

@Injectable({
  providedIn: 'root',
})
export class EnumService {
  constructor() {}

  onGetMasterDataTypes(): Array<NameValuePair> {
    let map: NameValuePair[] = [];

    for (var n in MasterDataTypes) {
      if (parseInt(n) > 0) {
        var strValue = MasterDataTypes[n];
        var value = parseInt(n);

        var convertdStr = this.toNormalCase(strValue);

        map.push({ value: value, name: convertdStr });
      }
    }

    return map;
  }

  toNormalCase(camel) {
    const camelCase = camel.replace(/([a-z])([A-Z])/g, '$1 $2').split(' ');

    let flat = '';

    camelCase.forEach((word) => {
      flat = flat + word.charAt(0).toUpperCase() + word.slice(1) + ' ';
    });
    return flat;
  }
}
